import React, { useState } from "react";
import ezIcon from "../../assets/images/brand/ez-icon.png";
import wordmarkRed from "../../assets/images/brand/ezeitpro-wordmark-red.png";
import wordmarkWhite from "../../assets/images/brand/ezeitpro-wordmark-white.png";

// EzeitPro brand: the EZ icon, optionally followed by the "EzeitPro" wordmark.
//   variant "full" (default) = icon + wordmark, "icon" = icon only (collapsed sidebar, tight spots).
//   tone "light" = for light backgrounds (red wordmark), "dark" = for dark backgrounds (white wordmark).
//   height is the icon's height in px; the wordmark scales with it.
// If the wordmark image cannot load, the word is drawn as text next to the icon instead.
const WORDMARK_RATIO = 0.52;
const GAP_RATIO = 0.3;
const WORDMARK_ASPECT = 565 / 120;
const BRAND_RED = "#C8194A";

const BrandLogo = ({ variant = "full", tone = "light", height = 32, className, style }) => {
  const [wordmarkFailed, setWordmarkFailed] = useState(false);
  const isDark = tone === "dark";
  const wordmarkHeight = Math.round(height * WORDMARK_RATIO);

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        flexShrink: 0,
        lineHeight: 1,
        gap: Math.round(height * GAP_RATIO),
        ...style,
      }}
    >
      <img
        src={ezIcon}
        alt={variant === "icon" ? "EzeitPro" : ""}
        style={{ height, width: height, display: "block", flexShrink: 0 }}
      />
      {variant !== "icon" &&
        (wordmarkFailed ? (
          <span
            style={{
              fontWeight: 800,
              fontSize: Math.round(height * 0.6),
              letterSpacing: "-0.02em",
              color: isDark ? "#fff" : BRAND_RED,
              whiteSpace: "nowrap",
            }}
          >
            EzeitPro
          </span>
        ) : (
          <img
            src={isDark ? wordmarkWhite : wordmarkRed}
            alt="EzeitPro"
            onError={() => setWordmarkFailed(true)}
            style={{
              height: wordmarkHeight,
              width: Math.round(wordmarkHeight * WORDMARK_ASPECT),
              display: "block",
              flexShrink: 0,
            }}
          />
        ))}
    </span>
  );
};

export default BrandLogo;
